import {kFlashImages} from "../../../constants/images";
import {kFlashTexts, kSystemTexts} from "../../../constants/texts";

export default function CoursesNoGradeSelected() {
    // Used in ParameterSubthemesContent to display
    // message when no Grade has been selected

    // BUILD
    return (
        <div className={"animate-appear w-full h-full flex flex-col justify-start items-center shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] mt-[24px]"}>
            <div className={"bg-backgroundLight5 w-full flex items-center shadow-[inset_0px_1px_2px_rgba(82,96,120,1)]"}>
                <div className={"flex justify-start items-center space-x-[4px] w-2/5 px-[16px] py-[12px] border-r-[1px] border-greyLight3"}>
                    <span className={"text-[16px] font-medium text-greyLight11"}>
                        {kSystemTexts.themes}
                    </span>
                </div>
                <div className={"w-3/5 px-[16px] flex justify-start items-center py-[12px]"}>
                    <div className={"flex justify-start items-center space-x-[4px]"}>
                        <span className={"text-[16px] font-medium text-greyLight11"}>
                            {kSystemTexts.skills}
                        </span>
                    </div>
                </div>
            </div>
            <div className={"grow flex flex-col justify-center items-center space-y-[12px]"}>
                <div className={`h-[136px] min-h-[136px]`}>
                    <img className={"object-contain h-full"}
                         src={kFlashImages.noGradeSelected}
                         alt="Ours avec stylo et cahier" />
                </div>
                <span className={"w-[400px] font-medium text-center text-[16px] text-greyLight7 whitespace-pre-line"}>
                    {kFlashTexts.noGradeSelected}
                </span>
            </div>
        </div>
    );
}